<template>
  <div class="g-bottom">
    <div class="g-bottom-content">
      <div class="box" style="width:205px">
        <div class="box-title">About Us</div>
        <p @click="linkToHandle('https://www.chinadentalshow.com/Information/?cid=132')">About </p>
        <p @click="linkToHandle('https://www.chinadentalshow.com/Information/?cid=153')">Contact Us</p>
        <p @click="linkToHandle('https://www.chinadentalshow.com/Information/?cid=152')">Organizers</p>
      </div>
      <div class="box" style="width:465px">
        <div class="box-title">Contact Us</div>
        <p>Mr. Andy Bian</p>
        <p>Tel:+86 010 8455 6622</p>
        <p>Email:ce.bian@reedsinopharm.com</p>
      </div>
      <div class="box">
        <div class="img-box">
          <img src="https://www.heexpochina.com/r/cms/www/red/newPC/images/highsetedu.png"
            style="width: 109px;margin-right:18px">
          <img src="https://www.heexpochina.com/r/cms/www/red/newPC/images/guoyao.png" @click="lineTo1"
            style="width: 191px;">
        </div>
        <div style="padding-top:45px;">2022 © Reed Sinopharm Exhibitions Co., Ltd.</div>
      </div>
    </div>
    <p class="copyright">{{ new Date().getFullYear() }} &copy; 国药励展展览有限责任公司 | <span @click="linkTo"
        class="f-csp">京ICP备06050757号-23</span> | 京公网安备 11010502032094号</p>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
    };
  },
  watch: {},
  computed: {},
  methods: {
    lineTo1 () {
      window.open('https://www.reed-sinopharm.com/', '_blank');
    },
    linkTo () {
      window.open('http://beian.miit.gov.cn/', '_blank');
    },
    linkToHandle (url) {
      window.open(url, '_blank');
    },
  },
  created () { },
  mounted () { }
}

</script>

<style lang="scss" scoped>
.g-bottom { 
  background-color: #232323;
  color: #bfbfbf;

  &-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    padding: 39px 0 50px;
  }

  .box {
    font-size: 14px;
    color: #bfbfbf;

    &-title {
      font-size: 16px;
      color: #fff;
      padding-bottom: 15px;
      cursor: pointer;
    }

    p {
      line-height: 1.7;
      cursor: pointer;
    }
  }

  .copyright {
    text-align: center;
    font-size: 14px;
    color: #bfbfbf;
    padding-bottom: 25px;
  }

  .img-box {
    display: flex;
    align-items: center;

    img {
      display: inline-block;
      cursor: pointer;
    }
  }
}</style>
